<template>
  <div class="home" ref="home">
    <div class="content">
      <!-- banner -->
      <Banner :banners="['images/banner.png']"></Banner>

      <!-- 导航 -->
      <nav class="ground">
        <img
          class="ceping"
          @click="schoolClickHandle"
          src="../assets/index-list-1.png"
          alt=""
        />
        <img
          class="xiugai"
          @click="cepingClickHandle"
          src="../assets/index-list-2.png"
          alt=""
        />
        <img
          class="baoming"
          @click="talentClickHandle"
          src="../assets/index-list-3.png"
          alt=""
        />
        <img
          class="outLink"
          @click="outLink"
          src="../assets/index-list-4.png"
          alt=""
        />
      </nav>

      <!-- 内推企业 -->
      <LogoSwiper :row="2" title="内推企业" desc="查看更多" :logo="hotCo" />

      <video
        class="videos"
        poster="../assets/video-img.png"
        src="http://evp.chinaceotv.com/video/2020/xs/01.mp4"
        controls
      ></video>
      <h1>招聘职位</h1>
      <Joblist
        ref="joblist"
        :place="'home'"
        :selector="['func', 'degree', 'search']"
      />
      <!-- <div class="job_banner">
        <img  src="../assets/job_banner.png" alt="">
        <p>网站升级敬请期待</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import Icon from "@/components/Icon";
import Joblist from "@/components/Joblist";
// import Banner from '@/components/Banner'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Banner from "../components/Banner.vue";
import LogoSwiper from "../components/LogoSwiper.vue";

import { checkLogin } from "@/decorator.js";

export default {
  name: "Home",
  data() {
    return {
      scroll: null,
      hotCo: [
        { image: "images/hot/1.png", name: "浙江智臾科技有限公司" },
        { image: "images/hot/2.png", name: "杭州耳青聪科技有限公司" },
        { image: "images/hot/3.png", name: "浙江大学计算机创新技术研究院" },
        { image: "images/hot/4.png", name: "杭州云合智网技术有限公司" },
        { image: "images/hot/5.png", name: "标储信息科技（浙江）有限公司" },
        { image: "images/hot/6.png", name: "传化智联股份有限公司" },
        { image: "images/hot/7.png", name: "杭州领图信息科技有限公司" },
        { image: "images/hot/8.png", name: "杭州智芯科微电子科技有限公司" },
        { image: "images/hot/9.png", name: "浙江地芯引力科技有限公司" },
        { image: "images/hot/10.png", name: "浙江柔灵科技有限公司" },
        { image: "images/hot/11.png", name: "浙江亚太机电股份有限公司" },
        { image: "images/hot/12.png", name: "浙江省北大信息技术高等研究院" },
        { image: "images/hot/13.png", name: "浙江大胜达包装股份有限公司" },
      ],
    };
  },

  methods: {
    disableScroll() {
      // console.log('外部停止')
      if (this.scroll.enabled) this.scroll.disable();
    },
    enableScroll() {
      // console.log('外部启动')
      if (!this.scroll.enabled) this.scroll.enable();
    },
    scrollToList(callback) {
      this.scroll.scrollToElement(".selector-bar", 300);
      if (callback) callback();
    },
    talentClickHandle() {
      this.$router.push("/service");
    },

    outLink() {
      var r = confirm("您即将离开前程无忧官方招聘网站，前往第三方招聘平台，是否确认前往？");
      if (r == true) {
        window.location.href = "https://www.wenjuan.com/s/UZBZJv4hMK/";
      } 
    },
    // @checkLogin()
    groundHref(index) {
      this.$router.push({ name: "GroundFrame", params: { initTab: index } });
    },
    //@checkLogin()
    cepingClickHandle() {
      this.$router.push("/talentall");
    },
    schoolClickHandle() {
      this.$router.push("/intrduce");
    },
  },

  mounted() {
    // 初始化home页为 scroll-wrapper
    this.$nextTick(() => {
      // 初始化 betterScroll
      this.scroll = new BScroll(this.$refs.home, {
        click: true,
        momentumLimitTime: 250,
        bounceTime: 250,
        bounce: {
          top: true,
          bottom: false,
          left: true,
          right: true,
        },
      });
      // 默认禁用joblist滚动
      this.$eventBus.emit("jobListScrollDisable");

      // 当外部滚动触底,内部滚动开启
      this.scroll.on("scrollEnd", (e) => {
        if (e.y <= this.scroll.maxScrollY) {
          this.$eventBus.emit("jobListScrollEnable");
        } else {
          this.$eventBus.emit("jobListScrollDisable");
        }
      });
    });
    // 在数据加载完成后再次刷新scroll
  },
  created() {
    // 注册全局滚动事件接口
    this.$eventBus.on("homeScrollDiable", this.disableScroll);
    this.$eventBus.on("homeScrollEnable", this.enableScroll);
    this.$eventBus.on("homeScrollToList", this.scrollToList);
    this.$eventBus.on("scrollRefresh", () => {
      this.scroll.refresh();
    });

    // 调用数据接口获取数据
    this.$store.commit("jobListGetBySelector", { place: "home" });
    // setTimeout(()=>{this.$store.commit('jobListNextPage', {place: 'home'})}, 1000)  // 翻页测试
    this.$store.commit("funcTypeInit");
  },
  activated() {
    if (this.scroll) this.$eventBus.emit("scrollRefresh");
  },
  components: {
    Icon,
    Joblist,
    Banner,
    LogoSwiper,
    swiperSlide,
    swiper,
  },
};
</script>

<style lang="scss">
.home {
  height: 100%;
  background: #edf2fa;
  .content {
    padding: 0 16px;
    font-size: 0;
    background: #edf2fa;
    .videos {
      width: 96%;
      height: 404px;
      display: block;
      margin: 30px auto 0 auto;
    }
    .job_banner {
      position: relative;
      width: 100%;

      > img {
        width: 100%;
      }
      > p {
        font-size: 25px;
        color: rgb(179, 185, 189);
        position: absolute;
        left: 50%;
        top: 70%;
        transform: translateX(-50%);
      }
    }
    .topline {
      width: 750px;
      position: relative;
      left: -16px;
    }
    .banner {
      margin-top: 16px;
    }
    .ground {
      margin-top: 16px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .ceping,
      .xiugai,
      .baoming,
      .outLink {
        width: 320px;
        height: 140px;
      }
      .baoming,
      .outLink {
        margin-top: 30px;
      }
    }
    .hot-swiper {
      margin: 16px auto 0;
      width: 688px;
      overflow: visible !important;
      img {
        display: block;
        width: 160px;
        height: 160px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
      }
      a:nth-child(2) {
        display: block;
        margin-top: 16px;
      }
    }
    .hot-pagination {
      margin: 40px auto 0;
      width: 160px;
      height: 8px;
      background: rgba(229, 229, 229, 1);
      border-radius: 4px;
      display: flex;
      .hot-bullet {
        flex: 1;
      }
      .hot-bullet-active {
        background: rgba(26, 72, 156, 1);
        border-radius: 4px;
      }
    }
    .video {
      margin-top: 64px;
      width: 100%;
      border-radius: 8px;
    }
    > h1 {
      margin-top: 64px;
      margin-bottom: 16px;
      font-size: 34px;
      height: 34px;
      font-weight: bold;
      color: #333333;
      line-height: 1;
      display: flex;
      align-items: center;
      &::before {
        content: "";
        display: inline-block;
        margin-right: 8px;
        width: 8px;
        height: 8px;
        background: #333333;
        box-shadow: 0 12px 0 0 #333333, 0 -12px 0 0 #333333;
        border-radius: 1px;
      }
      > span {
        flex: 1;
        font-size: 24px;
        color: rgba(102, 102, 102, 1);
        font-weight: 400;
        line-height: 32px;
        text-align: right;
      }
    }
  }
}
</style>